import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

const getBaseParams = (filters = {}) => {
  const companyId = store.getState().authState.companyId;
  const branchId = store.getState().authState.branchId;
  const params = {
    fromDate: filters.fromDate,
    toDate: filters.toDate,
    companyId: companyId || '',
    branchId: branchId || '',
  };
  if (filters.periodType === 'businessDay') {
    params.periodType = 'businessDay';
    params.startBusinessDayId = filters.startBusinessDayId;
    params.endBusinessDayId = filters.endBusinessDayId;
  }
  if (filters.cashierRegistryId) params.cashierRegistryId = filters.cashierRegistryId;
  if (filters.cashierId) params.cashierId = filters.cashierId;
  if (filters.customerId) params.customerId = filters.customerId;
  if (filters.businessVertical) params.businessVertical = filters.businessVertical;
  return params;
};

export const fetchSalesBusinessDays = ({ fromDate, toDate }) => {
  const companyId = store.getState().authState.companyId;
  const branchId = store.getState().authState.branchId;
  return Axios.get('/api/dashboard/reports/sales/business-days', {
    params: {
      companyId: companyId || '',
      branchId: branchId || '',
      fromDate,
      toDate,
    },
  }).then((res) => {
    if (res.data && res.data.success) return res.data.data || [];
    const message = (res.data && res.data.error) || 'Failed to load business days';
    throw new Error(message);
  });
};

export const fetchSalesSummary = (filters) => {
  const params = getBaseParams(filters);
  return Axios.get('/api/dashboard/reports/sales/summary', { params }).then(
    (res) => (res.data && res.data.success ? res.data.data : [])
  );
};

export const fetchSalesChartData = (filters) => {
  const params = getBaseParams(filters);
  return Axios.get('/api/dashboard/reports/sales/chart', { params }).then(
    (res) => (res.data && res.data.success ? res.data.data : [])
  );
};

export const fetchPaymentMethodBreakdown = (filters) => {
  const params = getBaseParams(filters);
  return Axios.get('/api/dashboard/reports/sales/payment-methods', { params }).then(
    (res) => (res.data && res.data.success ? res.data.data : [])
  );
};

export const fetchCompanyType = () => {
  const companyId = store.getState().authState.companyId;
  if (!companyId) return Promise.resolve(null);
  return Axios.get('/api/dashboard/company/profile', { params: { companyId } })
    .then((res) => (res.data && res.data.success ? res.data.data?.type ?? null : null))
    .catch(() => null);
};

export const fetchRestaurantSalesSummary = (filters) => {
  const params = getBaseParams(filters);
  return Axios.get('/api/dashboard/reports/sales/restaurant-summary', { params }).then(
    (res) => (res.data && res.data.success ? res.data.data : [])
  );
};

export const fetchSalesReportData = (filters) => {
  const { businessVertical, ...sharedFilters } = filters || {};
  const summaryFilters = businessVertical
    ? { ...sharedFilters, businessVertical }
    : sharedFilters;
  return Promise.all([
    fetchSalesSummary(summaryFilters),
    fetchSalesChartData(sharedFilters),
    fetchPaymentMethodBreakdown(summaryFilters),
  ]).then(([summaryMetrics, chartData, paymentMethods]) => ({
    summaryMetrics,
    chartData,
    paymentMethods,
  }));
};

export const exportSalesReportExcel = (filters) => {
  const params = getBaseParams(filters);
  return Axios.get('/api/dashboard/reports/sales/export-excel', {
    params,
    responseType: 'blob',
  });
};
